1<template lang="html">
  <transition name="fade" mode="out-in">
    <flatCommissionField :commissionData="commissionData" v-if="commissionData.value.type == 'flat'"></flatCommissionField>
    <splitCommissionField :commissionData="commissionData" v-else-if="commissionData.value.type == 'split'"></splitCommissionField>
    <commissionButtons :commissionData="commissionData" :agent="agent" :updateDefaults="updateDefaults" v-else></commissionButtons>
  </transition>
</template>
<script>
  import flatCommissionField from './_flatCommissionField.vue'
  import splitCommissionField from './_splitCommissionField.vue'
  import commissionButtons from './_commissionButtons.vue'
  export default {
    props: ['commissionData', 'agent', 'updateDefaults'],
    components: {
      flatCommissionField,
      splitCommissionField,
      commissionButtons
    }
  }
</script>
<style lang="scss">
</style>